import type { PaymentRequestDto, PaymentResultDto } from './dto/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  processPayment = (dto: PaymentRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PaymentResultDto>({
      method: 'POST',
      url: '/api/app/payment/process-payment',
      body: dto,
    },
    { apiName: this.apiName,...config });
}